import React from 'react'
import { Link } from 'react-router-dom'
import {ReactComponent as ReactBgImage} from '../../src/assets/images/undraw_content_creator_re_pt5b.svg'

function Instructions() {
  return (
    <div className='h-full w-full py-8'>
       <div className='w-11/12 mx-auto flex flex-col gap-6 lg:w-8/12 pt-12 pb-10 sm:pt-14 md:px-14 md:shadow-lg'>
            <div className='space-y-5'>
                <h1 className='text-custom-blue font-bold text-2xl lg:text-3xl'>
                    Instructions <span className='text-custom-yellow'>&</span> Guides
                </h1>
                <p className='text-custom-brown text-base lg:text-lg'>
                    Kindly read the instructions below. Ensure to provide the required resources and information needed
                    in the correct format.
                </p>
            </div>
            <div className='flex flex-col gap-8 box-border w-full text-custom-brown text-base'>
                <div className='mx-auto sm:w-9/12'>
                    <ReactBgImage className='w-full h-full'/>
                </div>
                <p className='text-custom-brown text-base lg:text-lg'>
                    There are 10 main sections every CV belonging to an academic staff of OAU is expected to include. 
                    These sections are Personal Data, Educational Background, 
                    Work Experience, Membership of Professional Bodies, Publications, Professional Accomplishments, 
                    Conferences, Seminars and Workshops Attended, Current Research Activities, Other Relevant Information, and 
                    Contribution to Knowledge.
                </p>
                <div>
                    <p className='mb-4 text-custom-brown text-base lg:text-lg'>
                        To make the CV building process easier and faster, the 10 sections have been organized into 7 stages. 
                        Your response is to be provided mainly through; however, the "Professional Membership and Publications" stage (stage 5) requires uploading some documents. 
                        These documents should contain the information needed for the said stage. The required information and template documents are listed below. The template documents 
                        provide the format for the expected input, and you are advised to edit the document following the sample provided in it. The sample serves as a guideline and should be 
                        removed before uploading the document. 
                        The required information and their respective documents are:
                    </p>
                    <ol className='mt-2 list-decimal list-inside space-y-3  text-base lg:text-lg'>
                        <li>
                            Published Journal Articles, &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Journal_Publications.xlsx' target='_blank' download>
                                Click here to download.
                            </Link> 
                        </li>
                        <li>
                            Contribution in Books, &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Book_Contribution.xlsx' target='_blank' download>
                                Click here to download.
                            </Link> 
                        </li>
                        <li>
                            Edited and Refereed Conference Proceedings (Type A: Refereed), &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Conference_paper.xlsx' target='_blank' download>
                                Click here to download.
                            </Link> 
                        </li>
                        <li>
                            Edited and Refereed Conference Proceedings (Type B: Non Refereed), &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Conference_paper.xlsx' target='_blank' download>
                                Click here to download.
                            </Link>
                        </li>
                        <li>
                            Articles Accepted for Publication, &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Articles_accepted_for_Publications.xlsx' target='_blank' download>
                                Click here to download.
                            </Link>
                        </li>
                        <li>
                            Manuscripts Submitted for Publication, &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Manuscripts_for_publication.xlsx' target='_blank' download>
                                Click here to download.
                            </Link>
                        </li>
                        <li>Creative Works/Patents, &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Patents_Creative_work.xlsx' target='_blank' download>
                                Click here to download.
                            </Link>
                        </li>
                        <li>
                            Technical Report, &nbsp;
                            <Link className='cursor-pointer underline text-custom-yellow hover:text-red-700' to='/documents/Technical_Report.xlsx' target='_blank' download>
                                Click here to download.
                            </Link> 
                        </li>
                    </ol>
                </div>
                <p className='text-custom-brown text-base lg:text-lg'>
                    <span className='text-custom-blue font-bold'>Note:</span> &nbsp; 
                    Ensure to leave requested information that does not apply to you blank or without any document upload to avoid errors. Also, download and fill out the required documents before starting. Ensure to follow the sample provided in the document
                    and remove the sample before uploading the documents. 
                </p>
            </div>
            
            <div className='flex'>
                <Link to="/create-cv">
                    <p className='py-4 w-[170px] text-center text-white font-medium text-base lg:text-lg rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer'>
                        Get Started
                    </p>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default Instructions